// constants
import { Modals } from 'constants/index'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// utils
import { handleError } from 'utils/errors/handlers'

interface Params {
  entity: { id?: string; color?: string }
  defaultColor?: string
  update: (options: { variables: { id: string; input: { color: string } } }) => Promise<void>
}

// Opens the shared color picker for a plan item (objective / KPI / action) and saves the picked color.
export const usePlanItemColorPicker = ({ entity, defaultColor, update }: Params) => {
  const { showModal } = useShowModal({ modalType: Modals.SET_COLOR_MODAL })

  return () =>
    showModal({
      width: 'sm',
      initialColor: entity.color || defaultColor,
      onSubmit: async (data) => {
        // the picker returns a color object, an untouched initial value stays a hex string
        const color = data?.color?.hex || data?.color

        if (!color) {
          return
        }

        try {
          await update({ variables: { id: entity.id, input: { color } } })
        } catch (error) {
          handleError(error, 'usePlanItemColorPicker.onSubmit')
        }
      }
    })
}
